import React, { FC } from 'react';
import { IdeaFormInput } from '@buyside/util/researchSubmission';
import { useWatch } from 'react-hook-form';
import classNames from 'classnames';

import InputField from '@buyside/components/presentation/Fields/inputField';

import styles from '../detailsStyles.scss';
import fieldStyles from '@buyside/components/presentation/Fields/fieldStyles.scss';

const PairTradeFields: FC<{ isDraft: boolean }> = ({ isDraft }) => {
  const isPairTrade = useWatch<IdeaFormInput, 'positions'>({ name: 'positions' }).length === 2;

  if (isPairTrade)
    return (
      <div className={styles.pairTradeDetailsFields}>
        <div className={classNames(styles.pairRatioFields, fieldStyles.field, fieldStyles.medium)}>
          <label data-title>Pair Ratio</label>
          <div className={styles.pairRatio}>
            <InputField
              disabled={!isDraft}
              inputProps={{ min: 0 }}
              name="pairRatio[0]"
              type="number"
            />
            <strong>:</strong>
            <InputField
              disabled={!isDraft}
              inputProps={{ min: 0 }}
              name="pairRatio[1]"
              type="number"
            />
          </div>
          <small>Use total amounts invested, not total shares</small>
        </div>
        <InputField
          disabled={!isDraft}
          endAdornment="%"
          inputProps={{ min: 0 }}
          label="Target Return"
          name="returnTarget"
          type="number"
        />
      </div>
    );

  return null;
};

export default PairTradeFields;
